import {
  FlexColumn, FlexGrow, ModelAlphaInput, Flex,
  IconButton,
  ModelInput,
  useModelFormUpdate,
  useFormConfigurationContext,
} from '@equifinance/shared';
import styled from 'styled-components';
import {
  useChecklistContext,
} from '../../../../../../contexts';
import { ChecklistSection } from '../../../../ChecklistPage';
import { GenericSection } from '../../../GenericSection';
import { DeleteIcon, PlusIcon } from '../../../../../Account/components/Icons';
import { LinkButton } from '../../common';

const TitleSectionWrapper = styled(FlexColumn)`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[9]};
  gap: ${theme.padding[5]};
`}`;

const InputRow = styled(Flex)`
  width: 30%;
`;

const Banner = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;

const BannerStart = styled(FlexGrow)`${({ theme }) => `
  background: ${theme.colours.primary[3]};
  color: ${theme.colours.neutral[10]};
  padding: ${theme.padding[2]};
  padding-left: ${theme.padding[4]};
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.bolder};
`}`;

const BannerEnd = styled(FlexGrow)`${({ theme }) => `
  display: flex;
  justify-content: end;
  padding: ${theme.padding[2]};
  background: ${theme.colours.primary[8]};
  padding-right: ${theme.padding[4]};
`}`;

const AddButton = styled(LinkButton)`${({ theme }) => `
  color: ${theme.colours.primary[1]};
  font-weight: ${theme.fontWeight.bolder};
  font-size: ${theme.fontSize[1]};
  line-height: unset;
`}`;

const AddIcon = styled(PlusIcon)`${({ theme }) => `
  font-size: ${theme.fontSize[1]};
`}`;

const TitleDetailsList = styled(FlexColumn)`${({ theme }) => `
  padding: 0 ${theme.padding[10]};
  gap: ${theme.padding[5]};
`}`;

const TitleDetailsInputRow = styled(InputRow)`${({ theme }) => `
  width: 45%;
  gap: ${theme.padding[5]};
  align-items: center;
`}`;

const DeleteButton = styled(IconButton)`${({ theme }) => `
  margin-top: ${theme.padding[8]};
  margin-left: ${theme.padding[8]};
`}`;

export default function TitleDetailsSection() {
  const { checklist } = useChecklistContext();

  const { sendOffer } = checklist ?? {};

  const { titleDetails } = sendOffer ?? {};

  const { isDisabled } = useFormConfigurationContext();

  const update = useModelFormUpdate();

  const addTitles = () => {
    if (isDisabled) return;

    update({ 'sendOffer.titleDetails.titleNumbers': [...(titleDetails?.titleNumbers ?? []), { titleNumber: '' }] });
  };

  const deleteTitle = (removeAt: number) => {
    if (isDisabled) return;
    const newTitles = titleDetails?.titleNumbers.filter((_, i) => i !== removeAt);
    update({ 'sendOffer.titleDetails.titleNumbers': newTitles });
  };

  return (
    <GenericSection
      id="title-details"
      subSection={ChecklistSection.SEND_OFFER_TITLE_DETAILS}
      level={1}
    >
      <TitleSectionWrapper>
        <InputRow>
          <ModelAlphaInput
            label="Applicant Name(s):"
            field="sendOffer.titleDetails.applicantNames"
            required
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="Security Address:"
            field="sendOffer.titleDetails.securityAddress"
            required
          />
        </InputRow>

        <Banner>
          <BannerStart>
            Title(s)
          </BannerStart>
          {!isDisabled && (
            <BannerEnd>
              <AddButton onClick={addTitles}>
                <AddIcon />
                Add
              </AddButton>
            </BannerEnd>
          )}
        </Banner>
        <TitleDetailsList>
          {titleDetails?.titleNumbers?.map(({ id }, i) => (
            <Flex key={`title-${id}`}>
              <TitleDetailsInputRow>
                <ModelInput
                  label={`Title ${i + 1}`}
                  field={`sendOffer.titleDetails.titleNumbers[${i}].titleNumber`}
                  mutateValue={(v) => v?.toUpperCase()}
                  required
                />
              </TitleDetailsInputRow>
              {!!i && <DeleteButton onClick={() => deleteTitle(i)}><DeleteIcon /></DeleteButton>}
            </Flex>
          ))}
        </TitleDetailsList>
      </TitleSectionWrapper>
    </GenericSection>
  );
}
